// Helper function to format font-family string with proper quotes matching Google Fonts CSS
export const formatFontFamily = (fontString) => {
  if (!fontString || typeof fontString !== "string") return "'Work Sans', sans-serif"
  const parts = fontString.split(",")
  const fontName = parts[0]?.trim() || "Work Sans"
  const fallback = parts[1]?.trim() || "sans-serif"
  return `'${fontName}', ${fallback}`
}

// Helper function to format heading font-family string
export const formatHeadingFontFamily = (fontString) => {
  if (!fontString || typeof fontString !== "string") return "'Playfair Display', serif"
  const parts = fontString.split(",")
  const fontName = parts[0]?.trim() || "Playfair Display"
  let fallback = parts[1]?.trim() || "serif"

  // Arima Madurai should use sans-serif instead of cursive
  if (fontName === "Arima Madurai") {
    fallback = "sans-serif"
  }

  return `'${fontName}', ${fallback}`
}

// Helper function to get paragraph font weight (300 for Raleway, 400 for others)
export const getParagraphFontWeight = (paragraphFont, paragraphRegularWeight) => {
  if (paragraphRegularWeight) return paragraphRegularWeight
  return paragraphFont?.includes("Raleway") ? "300" : "400"
}

const FONT_STYLE_PROPS = [
  "font",
  "font-family",
  "font-size",
  "font-weight",
  "font-style",
  "font-variant",
  "line-height"
]

const WYSIWYG_INLINE_STYLE_PROPS = [...FONT_STYLE_PROPS, "color"]

/**
 * Strip font-related inline styles from HTML so the theme controls typography on the live site.
 * WYSIWYG output can contain font-family/font-size etc. which would override the site theme.
 */
export const stripFontStylesFromHtml = (html) => {
  if (!html || typeof html !== "string") return html
  return stripInlineStylesFromHtml(html, FONT_STYLE_PROPS)
}

/**
 * Strip font and color inline styles from WYSIWYG HTML so section color mode controls typography.
 */
export const stripWysiwygInlineStylesFromHtml = (html) => {
  if (!html || typeof html !== "string") return html
  return stripInlineStylesFromHtml(html, WYSIWYG_INLINE_STYLE_PROPS)
}

const stripInlineStylesFromHtml = (html, propsToStrip) => {
  if (!html || typeof html !== "string") return html
  return html.replace(/\s+style="([^"]*)"/gi, (_match, styleContent) => {
    const cleaned = styleContent
      .split(";")
      .map((part) => part.trim())
      .filter((part) => {
        const prop = part.split(":")[0]?.trim().toLowerCase()
        return prop && !propsToStrip.includes(prop)
      })
      .join("; ")
    return cleaned ? ` style="${cleaned}"` : ""
  })
}
